<template>
  <component
    :is="isTable ? 'tr' : 'div'"
    class="list-card-item_content"
    :class="[{ row: row, isFlexRow: row && !isTable, 'no-padding': noPadding }]"
  >
    <component v-if="title" :is="isTable ? 'td' : 'div'" class="list-card-item_title mr-8">
      <span class="list-card-item_title-text">
        <i v-if="titleIcon" :class="titleIcon" class="mr-4" />
        {{ $t(title) }}
      </span>
      <ContentChip
        v-if="titleChipText && titleChipText !== ''"
        noWrap
        :color="titleChipColor"
        :textLabel="titleChipText"
      />
    </component>
    <slot name="title" />
    <component :is="isTable ? 'td' : 'div'" v-if="isloading" class="list-card-item_isloading">
      <SkeletonAnimate class="skekete" />
    </component>
    <component :is="isTable ? 'td' : 'div'" v-else>
      <p v-if="type === 'text' || type === 'number'" class="list-card-item_text">
        {{ textContent ? $t(textContent) : $t('無') }}
      </p>
      <div v-if="type === 'text' && images.length" class="list-card-item__text-attach-wrap">
        <LvImgList :imageList="images" @go-to="$emit('go-to', $event)" />
      </div>
      <div v-if="type === 'text' && attaches.length" class="list-card-item__text-attach-wrap">
        <LvDownloadFileBtn
          v-for="(attach_e, attach_k) in attaches"
          :key="attach_k"
          :num="attach_k"
          :id="attach_e.id"
          :url="attach_e.url"
          :name="attach_e.name"
          :hasScope="attach_e.hasScope"
          :fileType="attach_e.fileType"
          :chipList="attach_e.chipList"
          :download="attach_e.hasScope"
          :showMoreBtn="attach_e.showMoreBtn"
          :showDownloadBtn="attach_e.showDownloadBtn"
          :isClickable="attach_e.isClickable"
          :isImageViewable="_isImageViewable"
          :versionNumber="attach_e.versionNumber"
          class="list-card-item__text-attach"
          @go-to="$emit('go-to', $event)"
        />
      </div>
      <p v-if="type === 'valid-date-belongs-to'" class="list-card-item_text">
        {{ textContent && textContent !== 'Invalid date' ? textContent : $t('無') }}
      </p>
      <p v-if="type === 'valid-date'" class="list-card-item_text">
        {{ _validDate }}
      </p>
      <div v-if="type === 'remind-taker'" class="remind-taker">
        <WsTextChip001
          :leading-icon="leadingIcon"
          :text-label="time ? time : $t('未設定')"
          icon-xl
          font-size-lg
          blue
          thin
        />
        <LlAvatar v-if="avatarName" :image="avatarImage || ''" :text-label="avatarName" />
      </div>
      <div v-if="type === 'button'" class="button">
        <WsTextButton001 no-padding narrow primary :to="to" font-size-lg @click="buttonOnclick()">
          {{ textContent }}
        </WsTextButton001>
      </div>
      <div v-if="type === 'chip'" class="chip">
        <ContentChipsList
          :clickable="clickable"
          :chips="chip"
          :to="to"
          @system-click="systemClassClick($event)"
        />
      </div>
      <div v-if="type === 'attaches'" class="attaches">
        <LvDownloadFileBtn
          v-for="(attach_e, attach_k) in attaches"
          :key="attach_k"
          narrow
          :num="attach_k"
          :id="attach_e.id"
          :url="attach_e.url"
          :name="attach_e.name"
          :hasScope="attach_e.hasScope"
          :fileType="attach_e.fileType"
          :chipList="attach_e.chipList"
          :download="attach_e.hasScope"
          :showMoreBtn="attach_e.showMoreBtn"
          :showDownloadBtn="attach_e.showDownloadBtn"
          :isClickable="attach_e.isClickable"
          :isImageViewable="_isImageViewable"
          :versionNumber="attach_e.versionNumber"
          class="mt-8 mr-8 attach"
          @go-to="$emit('go-to', $event)"
        />
        <LvText v-if="!attaches || attaches.length === 0" h5>
          {{ $t('無') }}
        </LvText>
      </div>
      <div v-if="type === 'avatar'" class="avatar">
        <LlAvatar
          v-if="avatarName"
          :image="avatarImage || ''"
          :text-label="avatarName"
          :subTextLabel="subTextLabel"
          :time="time"
          :timeLabel="timeLabel"
        />
      </div>
      <div v-if="type === 'avatars'" class="avatar">
        <div v-if="avatars && avatars.length > 0">
          <LlAvatar
            v-for="(avatar_e, avatar_k) in avatars"
            :key="avatar_k"
            :image="avatar_e.avatar || ''"
            :text-label="avatar_e.name"
            :time="avatar_e.time"
            :timeLabel="avatar_e.timeLabel"
            :subTextLabel="avatar_e.subTextLabel"
            class="avatars-item"
          />
        </div>
        <LvText v-else h5>
          {{ $t('無') }}
        </LvText>
      </div>
      <div v-if="type === 'condition' && condition" class="condition">
        <WsChip001 :text="condition" color="yellow" />
      </div>
      <div v-if="type === 'condition' && overdue" class="condition">
        <WsChip001 :text="overdue" :color="color" />
      </div>
      <div v-if="type === 'condition-chip'" class="condition">
        <WsChip001 :text="textContent" :color="color" :leadingIcon="leadingIcon" />
      </div>
      <LvFlexBox v-if="type === 'chip-list'" gap8>
        <WsChip001
          v-for="(chipItem, chipIndex) in chipList"
          :key="chipIndex"
          :leading-img="chipItem.icon"
          :text="chipItem.text"
          :color="chipItem.color"
        />
      </LvFlexBox>
      <div v-if="type === 'text-button'" class="text-button">
        <p class="list-card-item_text">
          {{ textContent ? textContent : $t('無') }}
        </p>
        <WsTextButton001 primary no-padding bold @click="buttonOnclick()">
          {{ buttonText }}
        </WsTextButton001>
      </div>
      <div v-if="type === 'dropdown'" class="dropdown">
        <div class="dropdown-input">
          <slot name="dropdown" />
        </div>
      </div>
      <div v-if="type === 'html-text'" class="html-text">
        <WsHtmlText :value="textContent" />
      </div>
      <template v-if="type === 'link'">
        <LlLink :text-label="textContent" @click="$_onLinkClick()" />
      </template>
      <div v-if="type === 'link' && attaches.length" class="list-card-item__text-attach-wrap">
        <div v-for="(attach_e, attach_k) in attaches" :key="attach_k">
          <LvDownloadFileBtn
            :num="attach_k"
            :id="attach_e.id"
            :url="attach_e.url"
            :name="attach_e.name"
            :hasScope="attach_e.hasScope"
            :fileType="attach_e.fileType"
            :chipList="attach_e.chipList"
            :download="attach_e.hasScope"
            :showMoreBtn="attach_e.showMoreBtn"
            :showDownloadBtn="attach_e.showDownloadBtn"
            :isClickable="attach_e.isClickable"
            :isImageViewable="_isImageViewable"
            :versionNumber="attach_e.versionNumber"
            class="mt-8 ml-8 list-card-item__text-attach"
            @go-to="$emit('go-to', $event)"
          />
        </div>
      </div>
      <template v-if="type === 'links'">
        <div v-if="links && links.length">
          <LlLink
            v-for="(link, linkIndex) in _links"
            :key="linkIndex"
            :textLabel="link.text ? link.text : link.title ? link.title : ''"
            class="mb-8"
            @click="$_onClickLink(link)"
          />
          <WsTextButton001
            v-if="isCollapsable && links.length > 4"
            primary
            noPadding
            :leadingIcon="isActive.collapse ? 'icon-chevron-down' : 'icon-chevron-up'"
            @click="$_onToggleCollapse()"
          >
            {{ isActive.collapse ? $t('展開') : $t('收起') }}
          </WsTextButton001>
        </div>
        <LvText v-else h5>
          {{ textContent ? textContent : $t('無') }}
        </LvText>
      </template>
      <template v-if="type === 'slot'">
        <slot name="slot" />
      </template>
      <div v-if="_textIconList && _textIconList.length > 0">
        <TextIconList :iconList="_textIconList" />
      </div>
    </component>
  </component>
  <!-- </component> -->
</template>
<script>
export default {
  name: 'ListCardItem',
  props: {
    isloading: {
      type: Boolean,
      default: false,
    },
    isTable: {
      type: Boolean,
      default: false,
    },
    avatars: {
      type: Array,
      default() {
        return [];
      },
    },
    title: {
      type: String,
    },
    textContent: {
      type: [String, Number],
      default() {
        return this.$t('無');
      },
    },
    row: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    validStart: {
      type: String,
      default() {
        return this.$t('無');
      },
    },
    validEnd: {
      type: String,
      default() {
        return this.$t('無');
      },
    },
    time: {
      type: String,
    },
    avatarName: {
      type: String,
      default: '',
    },
    avatarImage: {
      type: String,
      default: '',
    },
    chip: {
      type: Array,
      default() {
        return [];
      },
    },
    condition: {
      type: String,
      default: '',
    },
    overdue: {
      type: String,
      default: '',
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: '',
    },
    attaches: {
      type: Array,
      default() {
        return [];
      },
    },
    images: {
      type: Array,
      default() {
        return [];
      },
    },
    leadingIcon: {
      type: String,
      default: 'icon-remind-outline',
    },
    to: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    chipList: {
      type: Array,
      default() {
        return [];
      },
    },
    flexWidth: {
      type: [Number, String],
      default: 88,
    },
    links: {
      type: Array,
    },
    textIconList: {
      type: Array,
    },
    titleIcon: {
      type: String,
    },
    isCollapsable: {
      type: Boolean,
      default: false,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    subTextLabel: {
      type: String,
    },
    timeLabel: {
      type: String,
    },
    titleChipColor: {
      type: String,
      default: 'red',
    },
    titleChipText: {
      type: String,
    },
    disableOpenLink: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    _links() {
      return this.isCollapsable && this.links.length > 4
        ? this.isActive.collapse
          ? this.links.slice(0, 4)
          : this.links
        : this.links;
    },
    _validDate() {
      const start = this.validStart && this.validStart !== '' ? this.validStart : this.$t('無');
      const end = this.validEnd && this.validEnd !== '' ? this.validEnd : this.$t('無');
      return this.validStart || this.validEnd ? `${start} - ${end}` : this.$t('無');
    },
    _textIconList() {
      return this.$_setTextIconList(this.textIconList);
    },
    _isImageViewable() {
      return this.$store.state.app.factory.isImageViewable;
    },
  },
  data() {
    return {
      isActive: {
        collapse: true,
      },
    };
  },
  methods: {
    buttonOnclick() {
      this.$emit('click');
    },
    systemClassClick($event) {
      this.$emit('system-click', $event);
    },
    $_onLinkClick() {
      if (this.disableOpenLink) {
        this.$emit('click-link');
        return;
      }
      window.open(this.textContent);
    },
    $_onClickLink($event) {
      this.$emit('click-law', $event);
    },
    $_setTextIconList(rawEffects) {
      if (!rawEffects) return [];
      const textIconList = [];
      rawEffects.forEach(type => {
        type.forEach(effect => {
          textIconList.push(effect);
        });
      });
      return textIconList;
    },
    $_onToggleCollapse() {
      this.isActive.collapse = !this.isActive.collapse;
      this.$emit('toggle-collapse', this.isActive.collapse);
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/component/list-card-item';
</style>
